import { VisitorManagementKioskTemplate } from "~ui/templates/VisitorManagementKioskTemplate/VisitorManagementKioskTemplate";

import { useVisitorManagementKioskFullscreen } from "./useVisitorManagementKioskFullscreen";
import { VisitorManagementVisitorActions } from "./VisitorManagementVisitorActions";

export function VisitorManagementKioskPage() {
  const { isFullscreen, requestFullscreen } = useVisitorManagementKioskFullscreen();

  return (
    <VisitorManagementKioskTemplate isFullscreen={isFullscreen} onRequestFullscreen={requestFullscreen}>
      <VisitorManagementVisitorActions density="kiosk" />
    </VisitorManagementKioskTemplate>
  );
}
